import { useEffect, useRef } from 'react';

// ── 히어로 이미지 스크롤 패럴랙스 (2026-09-08 사용자) ─────────────────────────────────────
//   "모든 히어로 이미지는 수직 스크롤 시 그 자체에서 약간의 세련된 애니메이션."
//   구현: 히어로 배경 이미지를 스크롤량의 일부만큼 아래로 translate(→ 스크롤보다 느리게 이동=패럴랙스 랙).
//     + 살짝 확대(scale)해 이동 시 가장자리 여백이 노출되지 않게 커버. rAF 스로틀로 성능 확보.
//   ★히어로는 페이지 최상단이라 window.scrollY가 곧 패럴랙스 입력값. reduce-motion 존중(정지+scale만).
//   적용: DomainPage·GuidePage·Products의 heroBg. (메인 Hero는 이미지↔영상 교대 모션 별도 → 미적용.)
export function useHeroParallax<T extends HTMLElement>(opts?: { factor?: number; scale?: number }) {
  const factor = opts?.factor ?? 0.15; // 스크롤 대비 이동 비율(작을수록 미묘)
  const scale = opts?.scale ?? 1.16;   // 커버용 확대(이동해도 가장자리 안 보이게)
  const ref = useRef<T>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // 모션 최소화 선호 시: 이동 없이 확대만(정적)
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.style.transform = `scale(${scale})`;
      return;
    }
    let raf = 0;
    const update = () => {
      raf = 0;
      const y = window.scrollY;
      el.style.transform = `translate3d(0, ${(y * factor).toFixed(1)}px, 0) scale(${scale})`;
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    window.addEventListener('scroll', onScroll, { passive: true });
    update(); // 초기 위치 세팅
    return () => { window.removeEventListener('scroll', onScroll); if (raf) cancelAnimationFrame(raf); };
  }, [factor, scale]);

  return ref;
}
